// Routeur minimal (History API) : quelques routes, aucun paquet de plus.
import { useEffect, useState } from 'preact/hooks'

export type Route =
  | { name: 'login' }
  | { name: 'home' }
  | { name: 'preferences' }
  | { name: 'feedback'; app: string; itemId?: string }
  | { name: 'settings'; app: string }
  | { name: 'keys'; app: string }
  | { name: 'members'; app: string }
  | { name: 'tower' }
  | { name: 'tower_approve'; code: string }
  | { name: 'superheroes' }
  | { name: 'not_found' }

export function parse(path: string): Route {
  const p = path.replace(/\/+$/, '') || '/'
  if (p === '/') return { name: 'home' }
  if (p === '/login') return { name: 'login' }
  if (p === '/preferences') return { name: 'preferences' }
  if (p === '/tower') return { name: 'tower' }
  if (p === '/superheroes') return { name: 'superheroes' }
  const ap = /^\/tower\/approve\/(T-\d+)$/i.exec(p)
  if (ap) return { name: 'tower_approve', code: ap[1].toUpperCase() }
  const m = /^\/apps\/([a-z][a-z0-9_-]{1,30})(?:\/(feedback|settings|keys|members))?(?:\/([0-9a-f-]{36}))?$/.exec(p)
  if (!m) return { name: 'not_found' }
  const [, app, section, id] = m
  if (!section) return { name: 'feedback', app }
  if (section === 'feedback') return { name: 'feedback', app, itemId: id }
  if (id) return { name: 'not_found' }
  return { name: section as 'settings' | 'keys' | 'members', app }
}

export function href(r: Route): string {
  switch (r.name) {
    case 'login':
      return '/login'
    case 'preferences':
      return '/preferences'
    case 'tower':
      return '/tower'
    case 'tower_approve':
      return `/tower/approve/${r.code}`
    case 'superheroes':
      return '/superheroes'
    case 'feedback':
      return r.itemId ? `/apps/${r.app}/feedback/${r.itemId}` : `/apps/${r.app}`
    case 'settings':
    case 'keys':
    case 'members':
      return `/apps/${r.app}/${r.name}`
    default:
      return '/'
  }
}

const listeners = new Set<() => void>()
window.addEventListener('popstate', () => listeners.forEach((l) => l()))

export function navigate(to: string, replace = false): void {
  if (to === location.pathname) return
  if (replace) history.replaceState(null, '', to)
  else history.pushState(null, '', to)
  listeners.forEach((l) => l())
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parse(location.pathname))
  useEffect(() => {
    const on = () => setRoute(parse(location.pathname))
    listeners.add(on)
    return () => {
      listeners.delete(on)
    }
  }, [])
  return route
}

/** Lien interne sans rechargement. */
export function onLinkClick(e: MouseEvent, to: string): void {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return
  e.preventDefault()
  navigate(to)
}
